import React from "react";
import { Row, Column } from "@/shared/ui/Blocks";
import { IconButton } from "@/shared/ui/IconButton";
import ProfileHeader from "@/features/profile/components/ProfileHeader";
import { Person } from "@/features/people/graphql/generated";
import MarkdownText from "@/shared/widgets/MarkdownText";
import { cleanupMarkdownFromTags } from "@/shared/utils/parsers/cleanupMarkdownFromTags";

export const PersonSummary = ({
  profile,
  summary,
}: {
  profile: Person;
  summary?: string;
}) => {
  return (
    <>
      <ProfileHeader
        initials={profile.initials || ""}
        name={profile.name || ""}
        avatarUrl={profile.avatar || ""}
        className="pl-8"
        canEdit={false}
        email={profile.email?.toString()}
        phone={profile.phone?.toString()}
        linkedin={profile.linkedin?.toString()}
      />
      {!!summary && (
        <Column className="mt-8 gap-4">
          <h3>Summary</h3>
          <MarkdownText text={cleanupMarkdownFromTags(summary)} />
        </Column>
      )}
    </>
  );
};
